import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scissors } from "lucide-react";
import LegalFooter from "./LegalFooter";

export default function AuthShell({
  side = "agency",
  title,
  subtitle,
  children,
  altLinkLabel,
  altLinkTo,
  altLinkDataTestId,
}) {
  const isAgency = side === "agency";
  return (
    <div className="min-h-screen grid lg:grid-cols-2 font-body">
      {/* Left visual */}
      <aside
        className={`relative hidden lg:flex flex-col justify-between p-10 border-r border-[var(--mp-ink)] ${
          isAgency ? "bg-[var(--mp-ink)] text-white" : "bg-[var(--mp-primary)] text-white"
        }`}
      >
        <Link
          to="/"
          data-testid="auth-brand-link"
          className="inline-flex items-center gap-2.5 w-fit"
        >
          <div className="h-9 w-9 rounded-xl bg-white grid place-items-center">
            <Scissors className="h-4 w-4 text-[var(--mp-ink)]" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-[15px] font-semibold tracking-tight">
              Marketing Parrucchieri
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.22em] opacity-80">
              SRL · Social Agency
            </div>
          </div>
        </Link>

        <div className="max-w-md">
          <div className="text-[10px] font-bold uppercase tracking-[0.24em] opacity-80">
            {isAgency ? "Area Agenzia" : "Area Cliente"}
          </div>
          <h1 className="font-display mt-4 text-5xl leading-[1.05] tracking-tighter font-semibold">
            {isAgency ? (
              <>
                Dentro la <br />
                macchina <br />
                creativa.
              </>
            ) : (
              <>
                Il tuo salone, <br />
                in prima <br />
                fila online.
              </>
            )}
          </h1>
          <p className="mt-6 opacity-85 leading-relaxed">
            {isAgency
              ? "Accesso riservato al team di Marketing Parrucchieri SRL. Le nuove registrazioni richiedono l'approvazione dell'amministratore."
              : "Registra il tuo salone e il referente per iniziare a usufruire dei servizi social dell'agenzia."}
          </p>
        </div>

        <div className="text-xs uppercase tracking-[0.22em] opacity-80">
          © Marketing Parrucchieri SRL
        </div>
      </aside>

      {/* Right form */}
      <main className="flex flex-col min-h-screen bg-[var(--mp-bg)]">
        <div className="flex items-center justify-between px-6 sm:px-10 py-5 border-b border-[var(--mp-border)]">
          <Link
            to="/"
            data-testid="auth-back-home"
            className="inline-flex items-center gap-2 text-sm text-[var(--mp-muted)] hover:text-[var(--mp-ink)]"
          >
            <ArrowLeft className="h-4 w-4" /> Torna alla home
          </Link>
          {altLinkLabel && altLinkTo && (
            <Link
              to={altLinkTo}
              data-testid={altLinkDataTestId}
              className="text-sm font-medium hover:underline"
            >
              {altLinkLabel}
            </Link>
          )}
        </div>

        <div className="flex-1 flex items-center justify-center px-6 sm:px-10 py-10">
          <div className="w-full max-w-md">
            <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-[var(--mp-muted)]">
              {isAgency ? "Agenzia" : "Cliente"}
            </div>
            <h2 className="font-display mt-2 text-3xl sm:text-4xl tracking-tight">{title}</h2>
            {subtitle && (
              <p className="mt-2 text-[var(--mp-muted)] text-sm">{subtitle}</p>
            )}
            <div className="mt-8">{children}</div>
          </div>
        </div>
        <LegalFooter />
      </main>
    </div>
  );
}
